// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__R9AKq","selected":"Chip_selected__3ZeWG"};